<template>
	<li
		class="flex items-center border-b-2 supportsHover:hover:border-b-current supportsHover:hover:text-black-primary"
		:class="department === departmentType ? 'text-black-primary' : 'border-b-transparent'"
	>
		<button type="button" class="h-full px-4 focus:-outline-offset-2" @click="setDepartmentSearch">
			<slot />
		</button>
	</li>
</template>

<script lang="ts" setup>
import useDepartment from "@/SearchApp/composables/use-department";
import useMostSuggestedRequest from "@/SearchApp/composables/use-most-suggested-request";
import useSearch from "@/SearchApp/composables/use-search";
import type { Department } from "@ocm/global-types";
import { tr_searchDepartmentToggle } from "@/SearchApp/services/dataLayer";

const props = defineProps<{
	departmentType: Department;
}>();

const { department } = useDepartment();
const { loadSuggestions } = useMostSuggestedRequest();
const { setUpRequest, focusSearch } = useSearch();

const setDepartmentSearch = (): void => {
	department.value = props.departmentType;
	loadSuggestions();
	setUpRequest();
	focusSearch();
	tr_searchDepartmentToggle({ action: "department-switch", label: props.departmentType, searchterm: undefined });
};
</script>
